import { Component, OnInit } from "@angular/core";
import { Menu, NavService } from "src/app/shared/services/nav.service";
import { LayoutService } from "src/app/shared/services/layout.service";
import { SwitcherService } from "../../../shared/services/switcher.service";
import { ShopService } from "../../services/e-commerce/shop.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import swal from "sweetalert2";
import { environment } from "../../../../environments/environment";
import { DataSharingService } from "../../../services/data.share.service";
import { HttpClient, HttpHeaders, HttpParams, HttpBackend } from '@angular/common/http';

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  standalone: false
})
export class HeaderComponent implements OnInit {
  public isCollapsed = true;
  adminData: any;
  BaseUrl = environment.BaseUrl;
  globalUrl: any;
  showPic: any;
  newNotificaton: boolean = false;
  loader: boolean = false;

  notificationList: any = [];

  notification: any = [];
  indexisReaded: any = null;
  indexisRead: any = null;
  indexisAnnouncement = null;

  constructor(
    private layoutService: LayoutService,
    public navServices: NavService,
    public modalService: NgbModal,
    public SwitcherService: SwitcherService,
    public ShopService: ShopService,
    public router: Router,
    private api: AdminService,
    private dataSharingService: DataSharingService
  ) {
    // console.log(this.menuItems?.length);
    this.dataSharingService.clearNotification.subscribe(value => {
      if (value != null && value == true) {
        this.newNotificaton = false;

        if (value) {
          this.getNotifications();
        }
      }

    });
    this.dataSharingService.notificationHeader.subscribe((item) => {
      if (item != null && item == true) {
        this.newNotificaton = true;
      } else {
        this.newNotificaton = false;
      }
    })

  }

  ngOnInit(): void {


    this.getNotifications();

    this.navServices.items.subscribe((menuItems) => {
      this.items = menuItems;
    });
    const data: any = localStorage.getItem("adminDetail");
    let data1 = JSON.parse(data);
    this.adminData = data1

    this.showPic = this.adminData.image != null ? this.BaseUrl + 'admin/' + this.adminData.image : null;
    this.globalUrl = this.BaseUrl + 'admin/';

    this.dataSharingService.headerProfile.subscribe(value => {

      const data: any = localStorage.getItem("adminDetail");
      let data1 = JSON.parse(data);
      this.adminData = data1

      this.showPic = this.adminData.image != null ? this.BaseUrl + 'admin/' + this.adminData.image : null;
      this.globalUrl = this.BaseUrl + 'admin/';
    })
    // document.querySelector(".main-content")?.addEventListener("click", () => {
    //   this.clearSearch();
    // });
    // this.text = "";
  }



  //  open(content:any) {
  //   this.modalService.open(content, {
  //     backdrop: "static",
  //     windowClass: "modalCusSty",
  //     size: "lg",
  //   });
  // }
  getNotifications() {
    console.log("aaa---")
    this.api.loader(false);
    let params = new HttpParams();

    params = params.append('isRead', '0');
    this.api.getData(apiUrl._getNotification, params)
      .subscribe(res => {
        this.notification = res.data.rows
        if (this.notification.length == 0) {
          this.newNotificaton = false;
        }
        this.notification.filter((item: any) => {
          if (item.isRead == 0) {
            this.newNotificaton = true
          }
        });

      })

  }
  toggleSidebar() {
    if ((this.navServices.collapseSidebar = true)) {
      document.querySelector("body")?.classList.toggle("sidenav-toggled");
    }
  }

  toggleSidebarNotification() {
    this.layoutService.emitSidebarNotifyChange(true);
  }

  toggleSwitcher() {
    this.SwitcherService.emitChange(true);
    document.querySelector("body")?.classList.remove("sidenav-toggled-open");
  }

  // Search
  public menuItems!: Menu[];
  public items!: Menu[];
  public text!: string;
  public SearchResultEmpty: boolean = false;

  Search(searchText: any) {
    if (!searchText) return (this.menuItems = []);
    // items array which stores the elements
    let items: any[] = [];
    // Converting the text to lower case by using toLowerCase() and trim() used to remove the spaces from starting and ending
    searchText = searchText.toLowerCase().trim();
    this.items.filter((menuItems: any) => {
      // checking whether menuItems having title property, if there was no title property it will return
      if (!menuItems?.title) return false;
      //  checking wheteher menuitems type is text or string and checking the titles of menuitems
      if (
        menuItems.type === "link" &&
        menuItems.title.toLowerCase().includes(searchText)
      ) {
        // Converting the menuitems title to lowercase and checking whether title is starting with same text of searchText
        if (menuItems.title.toLowerCase().startsWith(searchText)) {
          // If you want to get all the data with matching to letter entered remove this line(condition and leave items.push(menuItems))
          // If both are matching then the code is pushed to items array
          items.push(menuItems);
        }
      }
      //  checking whether the menuItems having children property or not if there was no children the return
      if (!menuItems.children) return false;
      menuItems.children.filter((subItems: any) => {
        if (
          subItems.type === "link" &&
          subItems.title.toLowerCase().includes(searchText)
        ) {
          if (subItems.title.toLowerCase().startsWith(searchText)) {
            // If you want to get all the data with matching to letter entered remove this line(condition and leave items.push(subItems))
            items.push(subItems);
          }
        }
        if (!subItems.children) return false;
        subItems.children.filter((subSubItems: any) => {
          if (subSubItems.title.toLowerCase().includes(searchText)) {
            if (subSubItems.title.toLowerCase().startsWith(searchText)) {
              // If you want to get all the data with matching to letter entered remove this line(condition and leave items.push(subSubItems))
              items.push(subSubItems);
            }
          }
        });
        return;
      });
      return (this.menuItems = items);
    });
    // Used to show the No search result found box if the length of the items is 0
    if (!items.length) {
      this.SearchResultEmpty = true;
    } else {
      this.SearchResultEmpty = false;
    }
    return;
  }

  clearSearch() {
    this.text = "";
    this.menuItems = [];
    this.SearchResultEmpty = false;
    return this.text, this.menuItems;
  }
  // logout
  logout() {
    swal
      .fire({
        icon: "warning",
        text: "Are you sure you want to logout ?",
        showCancelButton: true,
        confirmButtonColor: "#14141f",
        cancelButtonColor: "#939393",
        confirmButtonText: "Yes",
      })
      .then((result) => {
        if (result.value) {
          this.api.putData(apiUrl._logout, {}).subscribe(
            async (res) => {
              localStorage.removeItem("adminToken");
              localStorage.removeItem("adminDetail");
              localStorage.removeItem("firstName");
              localStorage.removeItem("lastName");
              localStorage.removeItem("image");
              localStorage.removeItem("s3Url");
              localStorage.removeItem("s3Folders");
              localStorage.removeItem("baseUrl");
              localStorage.removeItem("phoneNumber");
              localStorage.removeItem("fcmToken");
              localStorage.removeItem("userPermissions");
              localStorage.removeItem("userName");
              localStorage.removeItem("adminType");
              this.router.navigate(["/"]);
            },
            (err) => {
              // console.log(err, "errr");
            }
          );
        }
      });
  }
}
